
import CreateOrderProductInfo from './create-order-product';
export default class CreateOrder{
    pdfGuid: string;
    orderNumber: string;
    warehouseInfoId: number;
    expressDelivery: Array<string>;
    shippingMethods: string;
    orderLogisticsNumber: string;
    reMark: string;
    orderProductInfo: Array<CreateOrderProductInfo>;
    orderStatus: number;
    packageStatus: number;
    warehouseNote: string;
    orderType?: number;
    cargoCategory?: number;
    PlatformType?: number;
    site?: number;
    warehouseOrderType: number;
    constructor() {
        this.expressDelivery = [];
        this.orderProductInfo = [];
        this.PlatformType = 0;
    }
}
